import { ls } from "@i18n/translations";
import axios, { AxiosError } from "axios";

export function round(value: number, precision: number = 1, base?: number) {
  var multiplier = Math.pow(base || 10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export function checkStationOnline(station: any) {
  if (
    station &&
    (station.type === "STATION_WITH_LOCKERS" ||
      station.type === "SINGLE_BOX_STATION")
  ) {
    return (
      station.boxes && station.boxes.some((b: any) => !!b.active && !!b.online)
    );
  } else if (
    station &&
    (station.type === "ONLY_LOCKERS" || station.type === "ONLY_LOCKERS_NOPIN")
  ) {
    return (
      station.lockers &&
      station.lockers.some((b: any) => !!b.active && !!b.online)
    );
  } else {
    return (
      station?.sockets &&
      station.sockets.some((b: any) => !!b.active && !!b.online)
    );
  }
}

export function ValidateEmail(mail: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (re.test(mail)) {
    return true;
  }
  // alert('You have entered an invalid email address!');
  return false;
}

export function Validate4digitCode(mail: string) {
  const re = /^[0-9]{4}$/;
  if (re.test(mail)) {
    return true;
  }
  // alert('You have entered an invalid email address!');
  return false;
}

export function getSocketShortName(_socket: string, _socketName?: string) {
  if (
    _socketName &&
    _socketName.trim().length > 0 &&
    _socketName.startsWith("Presa-")
  ) {
    return _socketName.replace("Presa-", "").trim();
  }

  if (
    _socketName &&
    _socketName.trim().length > 0 &&
    _socketName.startsWith("Custom-")
  ) {
    return _socketName.replace("Custom-", "").trim();
  }

  switch (`${_socket}`) {
    case "0":
      return "1";
    case "1":
      return "2";
    case "2":
      return "3";
    case "3":
      return "4";
    default:
      return "";
  }
}

export const getErrorMessage = (error: any): string => {
  console.error(
    "ERROR",
    error?.error || error.message || error.status || error,
  );
  let errorMsg: string = "";
  if (axios.isAxiosError(error)) {
    errorMsg =
      error.response?.data?.error || error.message || error.code || ls.sww;
    if (typeof errorMsg === "string") {
      return getErrorMessage(new Error(errorMsg));
    }
    return String(errorMsg);
  }
  switch (typeof error) {
    case "string":
      return error;
    case "object":
      if (!error || !error.message) {
        return ls.sww;
      }
      if (
        error.networkError &&
        error.networkError.result &&
        error.networkError.result.errors.length
      ) {
        errorMsg = error.networkError.result.errors[0].message;
      }
      if (!errorMsg) {
        errorMsg = error.message;
      }
      errorMsg = errorMsg
        .replace("GraphQL error: ", "")
        .replace("Network error: ", "")
        .replace("Unexpected token T in JSON at position 0", ls.sww);
      const errorParsed = errorMsg.match(/^(.*): {".*$/);
      if (errorParsed) {
        errorMsg = errorParsed[1];
      }
      let errTranslated = ls.getString(errorMsg.replaceAll(" ", "_"));
      if (!errTranslated) {
        const deviceOfflineMatch = errorMsg.match(/device offline/);
        if (deviceOfflineMatch && deviceOfflineMatch.length > 0) {
          errTranslated = ls.deviceOffline;
        }
      }
      return errTranslated || errorMsg;
    case "undefined":
      return ls.sww;
    default:
      return ls.sww;
  }
};

export const catchErrors = (error: any, displayError: (e: string) => void) => {
  displayError(getErrorMessage(error));
};
